import styled from 'styled-components';

import { Prompt } from '@xemplo/prompt-dialog';
import { BodySmallMedium, Colour } from '@xemplo/style-constants';

export const PromptBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  ${BodySmallMedium};
  color: ${Colour.Gray[400]};
  > span:first-child {
    color: ${Colour.Gray[800]};
  }
  > *:nth-child(3) {
    margin-top: 16px;
  }
`;

export const CustomPrompt = styled(Prompt.Dialog)`
  overflow: visible;
`;
